import { Title } from '@components/atoms/Title';
import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface EntitySectionTitleProps extends PropsWithChildren, PropsWithClassProps {
  heading?: boolean;
}

export const EntitySectionTitle = ({ heading, classProps, children }: EntitySectionTitleProps) => {
  return heading ? (
    <Title
      level={2}
      classProps={{
        heading: twMerge(
          'tracking-widest text-sm mt-6 lg:text-sm text-gray-820 dark:text-gray-500 font-proxima-nova mb-2 font-semibold uppercase',
          classProps?.root,
        ),
      }}
    >
      {children}
    </Title>
  ) : (
    <div
      className={twMerge(
        'mt-6 mb-2 font-proxima-nova font-semibold text-gray-820 text-sm uppercase tracking-widest lg:text-sm dark:text-gray-500',
        classProps?.root,
      )}
    >
      {children}
    </div>
  );
};
